export default __webpack_public_path__ + "static/media/NEW IN.b048f9c0.jpg";